module.exports = {"message":"hello i18n !!","Header":{"Home":"Home","Courses":"Courses","Contact Us":"Contact Us","Search":"Search...","Login":"Login","Register":"Register","Profile":"Profile","Logout":"Logout","Book a demo":"Book a demo","English":"English","Arabic":"Arabic"}}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en.json
// module id = NuBg
// module chunks = 2